import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { Enums, Paths } from '@utils/constants';
import { axios } from '@utils/lib';
import { AxiosRequestConfig } from 'axios';
import { addLoading, removeLoading } from './appAction';

export const forceLogout = createAction('auth/forceLogout');

export const login = createAsyncThunk(
  'auth/login',
  async (body: ILoginForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<ILoginRes>(
        Enums.HTTP_METHOD.POST,
        Paths.LOGIN,
        body,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const response = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.LOGOUT,
      );
      return response.data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const changePassword = createAsyncThunk(
  'auth/changePassword',
  async (body: IChangePasswordForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { token, ...request } = body;
    const configs: AxiosRequestConfig | undefined = !token
      ? undefined
      : { headers: { Authorization: `Bearer ${token}` } };
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.CHANGE_PASSWORD,
        request,
        configs,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
